import React from 'react';

import GalleryDemoLayout from './GalleryDemoLayout';
import { useGalleryLightbox } from './GalleryLightbox';
import { PHOTOS } from './galleryDemoData';

/* Demo 1 — Masonry grid + hover captions + lightbox. */
const GalleryDemo = () => {
    const lb = useGalleryLightbox(PHOTOS);

    return (
        <GalleryDemoLayout
            demoLabel="Demo 1"
            kicker="Masonry Grid"
            title="Every Drop Counts"
            lead="Classic masonry layout — photos flow in natural heights. Hover for the caption, click any photo for the full-screen viewer."
        >
            <div className="wrap">
                <div className="gmasonry">
                    {PHOTOS.map((p, i) => (
                        <button
                            type="button"
                            className={"gcard reveal d" + ((i % 3) + 1)}
                            key={i}
                            onClick={() => lb.open(i)}
                            aria-label={`View photo: ${p.cap}`}
                        >
                            <img src={p.src} alt={p.cap} loading="lazy" />
                            <span className="gcard__icn" aria-hidden="true">
                                <svg viewBox="0 0 24 24" fill="none">
                                    <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
                                    <path d="M11 8v6M8 11h6M20 20l-3.5-3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                            </span>
                            <span className="gcard__ov">
                                <span className="gcard__cap">{p.cap}</span>
                            </span>
                        </button>
                    ))}
                </div>
            </div>
            {lb.lightbox}
        </GalleryDemoLayout>
    );
};

export default GalleryDemo;
